<template>
  <div>
    <input type="date" v-model="validFromDate"/>
    <input type="date" v-model="validUntilDate"/>
    <button class="btn btn-primary btn-sm" @click="$emit('update', [validFromDate, validUntilDate])">Speichern</button>
  </div>
</template>

<script>
export default {
  props: {
    article: Object
  },
  data() {
    return {
      validFromDate: null,
      validUntilDate: null
    }
  },
  watch: {
    article: {
      handler(newVal) {
        this.validFromDate = newVal.validFromDate
        this.validUntilDate = newVal.validUntilDate
      },
      immediate: true
    }
  }
}
</script>
